// Плашки PWA над страницей: нет связи с интернетом (данные на экране могут устареть, кнопки не сработают)
// и «платформа обновилась» — после выкатки новая версия уже загружена, страницу стоит обновить.
import { Button } from '@autoaff/ui';
import { RefreshCw, WifiOff } from 'lucide-react';
import { usePwa } from '../pwa';

export function NetBar() {
  const pwa = usePwa();
  if (!pwa.online)
    return (
      <div className="alert-bar net" role="status">
        <WifiOff aria-hidden />
        <div className="alert-text">
          <b>Нет связи с интернетом</b>
          <span>На экране — последние загруженные данные; кнопки заработают, когда связь вернётся.</span>
        </div>
      </div>
    );
  if (pwa.updated)
    return (
      <div className="alert-bar info" role="status">
        <RefreshCw aria-hidden />
        <div className="alert-text">
          <b>Платформа обновилась</b>
          <span className="hide-m">Обновите страницу, чтобы работать в новой версии.</span>
        </div>
        <Button size="sm" onClick={() => window.location.reload()}>
          Обновить
        </Button>
      </div>
    );
  return null;
}
